import { useEffect, useState, useRef } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import basePCUrl from '../../../Globals';
import { useQuery } from 'react-query';
import { fetchLinkAnalysisData } from '../../../utils/service';


export const useFetchLinkAnalysisAdmin = (finalUrl) => {
  //const [data, setData] = useState([]);
  const { getAccessTokenSilently } = usePortalAuth();

  const [state, setState] = useState({
    data: [],
    domainDetails: [],
    isLoading: true,
  });

  const useIsMount = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
      isMountRef.current = false;
    }, []);
    return isMountRef.current;
  };

  const isMount = useIsMount();

  const fetchLinkAnalysisAdmin = async () => {
    setState({ data: null, domainDetails: null, isLoading: true });

    const token = await getAccessTokenSilently();
    const headers = {
      Authorization: `Bearer ${token}`,
      Action: 'linkAnalysis',
      link: finalUrl,
      'Content-Type': 'application/json',
    };

    fetch(basePCUrl, {
      method: 'get',
      headers: headers,
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }

        response.json().then((data) => {

          setState({
            data: data,
            domainDetails: data.domainDetails,
            isLoading: false,
          });

        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  useEffect(() => {
    setState({ data: null, domainDetails: null, isLoading: null });

    if (!isMount)  {
      fetchLinkAnalysisAdmin();
    }
  }, [finalUrl]);

  return state;
};
export default useFetchLinkAnalysisAdmin;
